export const environment = "production";

export const backendEndpoint = {
  production: "https://midpage-app.onrender.com",
  development: "https://us-dev-backend.onrender.com",
};

export const extension_endpoint = backendEndpoint[environment] + "/extension";

const localhost = "http://localhost:3000";

export const nextJsEndpoint = {
  local: localhost,
  production: "https://app.midpage.ai",
  development: "https://webapp-git-dev-midpage.vercel.app",
};

export const clerkPublishableKey = {
  production: "pk_live_Y2xlcmsubWlkcGFnZS5haSQ",
  development: "pk_test_YWN0dWFsLXBvcnBvaXNlLTY0LmNsZXJrLmFjY291bnRzLmRldiQ",
};

export const segmentWriteKey = {
  production: "2SOKvKOIKF33nnDZEXIohHzueqPgOGp5",
  development: "OPnDPVhMP7M44Tp9odWrzOBJNR9GgHs9",
};

export const internalVersion = "0.0.1";
